import {z} from 'zod';

const multiStringParam = z.union([z.string(), z.array(z.string())]).optional();

export const mechanicQuerySchema = z.object({
  openedFrom: z.string().optional(),
  openedTo: z.string().optional(),
  closedFrom: z.string().optional(),
  closedTo: z.string().optional(),
  mechanic: multiStringParam,
  state: multiStringParam,
  variant: multiStringParam,
});

export type MechanicQuery = z.infer<typeof mechanicQuerySchema>;
